<template>
	<div>
		<!-- 顶部栏 -->
		<div class="topbar">
			<div>
				<el-input v-model="searchValue" size="small" placeholder="" prefix-icon="el-icon-search"
					class="search-input" @keypress.enter.native="search()" />
				<el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"
					@click.stop="search()">
					搜索
				</el-button>
			</div>
			<el-button type="primary" icon="el-icon-plus" size="small" @click.stop="openAddVideoTabDialog()">
				新增标签
			</el-button>
		</div>
		<!-- 内容 -->
		<el-table v-loading="loading" :data="videoTabList" :header-cell-style="{ background: '#F5F7FA' }"
			style="width: 100%; margin-bottom: 20px">
			<el-table-column prop="videoTabID" label="#" align="center" width="100" />
			<el-table-column label="创建者" align="center" width="200">
				<template #default="props">
					<el-avatar :key="props.row.avatar" :src="getImageUrl(props.row.avatar)"></el-avatar>
					<br />
					{{getName(props.row)}}
				</template>
			</el-table-column>
			<el-table-column label="创建时间" align="center" width="200">
				<template slot-scope="scope">
					{{ scope.row.createTime | formatDateTime }}
				</template>
			</el-table-column>
			<el-table-column prop="videoTabTitle" label="标题" align="center" />
			<el-table-column prop="videoTabTitle" label="关联视频数" align="center">
				<template #default='scope'>
					{{scope.row.videoList.length}}
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" width="350">
				<template slot-scope="scope">
					<el-button size="small" :type="scope.row.isDefault ? 'warning' : 'success'"
						@click.stop="setVideoTab(scope.row)">
						{{ scope.row.isDefault ? "取消默认" : "设为默认" }}
					</el-button>
					<el-button type="primary" size="small" @click.stop="openVideoListDialog(scope.row)">
						查看视频
					</el-button>
					<el-button size="small" type="primary" @click.stop="openEditVideoTabDialog(scope.row)">
						编辑
					</el-button>
					<el-button size="small" type="danger" @click.stop="deleteVideoTab(scope.row)">
						删除
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination v-show="totalCount > pageSize" background layout="prev, pager, next" :total="totalCount"
			:page-size="pageSize" :current-page="currentPage" @current-change="currentChange" />

		<!-- addVideoTagsDialog -->
		<el-dialog title="新增视频标签" :visible.sync="addVideoTagsDialog" width="60%">
			<el-form ref="videoTabFormRef" :model="addVideoTagsForm" status-icon :rules="videoTabFormRules">
				<el-form-item label="标题" label-width="80px" prop="videoTabTitle">
					<el-input v-model="addVideoTagsForm.videoTabTitle" autocomplete="off" style="width: 40%" />
				</el-form-item>
				<el-form-item label="是否默认" label-width="80px" prop="default">
					<el-radio-group v-model="addVideoTagsForm.isDefault">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>

				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="addVideoTagsDialog = false">
					取 消
				</el-button>
				<el-button type="primary" size="small" @click="addVideoTab()">
					确 定
				</el-button>
			</div>
		</el-dialog>

		<el-dialog title="预览" :visible.sync="previewVideoDialog" width="25%" :destroy-on-close='true'>
			<video :src="videoSrc" controls style="width: 100%"></video>
		</el-dialog>

		<!-- editVideoTagsDialog -->
		<el-dialog title="编辑视频标签" :visible.sync="editVideoTagsDialog" width="60%">
			<el-form :model="editVideoTagsForm">
				<el-form-item label="标题" label-width="40px">
					<el-input v-model="editVideoTagsForm.videoTabTitle" autocomplete="off" style="width: 40%" />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="editVideoTagsDialog = false">
					取 消
				</el-button>
				<el-button type="primary" size="small" @click="editVideoTab()">
					确 定
				</el-button>
			</div>
		</el-dialog>

		<!-- 标签视频列表 -->
		<el-dialog title="视频列表" :visible.sync="videoListDialog" width="60%">
			<!-- 内容 -->
			<el-table :data="videoList" :header-cell-style="{ background: '#F5F7FA' }"
				style="width: 100%; margin-bottom: 20px">
				<el-table-column prop="videoID" label="#" align="center" />
				<el-table-column prop="videoName" label="视频标题" align="center" />
				<el-table-column prop="nickname" label="创建者" align="center" show-overflow-tooltip />
				<el-table-column label="创建时间" align="center">
					<template slot-scope="scope">
						{{ scope.row.createTime | formatDateTime }}
					</template>
				</el-table-column>
				<el-table-column label="预览" align="center">
					<template slot-scope="scope">
						<el-button size="small" type="primary" @click.stop="previewVideo(scope.row)">
							预览
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-pagination v-show="videoListTotalCount > videoListPageSize" background layout="prev, pager, next"
				:total="videoListTotalCount" :page-size="videoListPageSize" :current-page="videoListCurrentPage"
				@current-change="videoListCurrentChange" />
		</el-dialog>
	</div>


</template>

<script>
	import {
		getAllVideoList,
		setVideo,
		addVideo,
		deleteOrBackVideo,
		getVideoTabList,
		setVideoTab,
		addVideoTab,
		updateVideoTab,
		deleteVideoTab,
		getColumnList,
	} from "@/api/videoCourse";
	import {
		getOSSUploadInfo
	} from "@/api/aliyun";
	import config from "@/utils/config";
	import {
		getDisplayName
	} from "@/utils/userutil"
	import {
		getCloudUrl,
	} from "@/utils/urlutil"
  import {getNavigationItemObj, setNavigationItemWithObj} from "@/utils/NavigationUtils";
	export default {
		data() {
			return {
        navigationKey:"videoCourseTabList",

				loading: false, // 加载开关

				searchValue: "", // 搜索内容
				totalCount: 0, // 列表总数
				pageSize: 10, // 单页条数
				currentPage: 1, // 当前页码
				previewVideoDialog: false, // 预览视频开关
				videoSrc: "", // 视频路径
				videoTabList: [], // 所有视频标签列表
				addVideoTagsDialog: false, // 添加视频标签对话框
				addVideoTagsForm: {}, // 添加视频标签表单
				editVideoTagsDialog: false, // 编辑视频标签对话框
				editVideoTagsForm: {}, // 编辑视频标签表单
				fileList: [],
				videoListDialog: false, // 标签对应视频列表开关
				videoList: [], // 标签对应视频列表
				videoListAll: [], //没有接口，自己记录关联的视频全部数据
				videoListTotalCount: 0,
				videoListPageSize: 10,
				videoListCurrentPage: 1,
				// 新增视频标签规则
				videoTabFormRules: {
					videoTabTitle: [{
						required: true,
						message: "必填项",
						trigger: "blur"
					}],
					// default: [{
					// 	required: true,
					// 	message: "必填项",
					// 	trigger: "blur"
					// }],
				},

			}
		},
		async created() {
      let navigationObj = getNavigationItemObj(this.navigationKey)
      this.currentPage = navigationObj.currentPage
      this.searchValue = navigationObj.searchValue

			this.getVideoTabList()
		},
		methods: {
			videoListCurrentChange(curPage) {
				this.getVideoList(curPage)
			},
			getVideoList(curPage) {
				this.videoListCurrentPage = curPage;
				// 获取关联视频数据
				let start = (this.videoListCurrentPage - 1) * this.videoListPageSize
				let end = start + this.videoListPageSize
				this.videoList = this.videoListAll.slice(start, end);
			},
			getName(user) {
				return getDisplayName(user)
			},
			getImageUrl(path) {
				return getCloudUrl(path)
			},
			/**
			 * 搜索
			 */
			search() {
				this.currentPage = 1;
				this.getVideoTabList();
			},
			/**
			 * 翻页
			 *
			 * @param {number} currentPage 当前页码
			 */
			currentChange(currentPage) {
				this.currentPage = currentPage;

				this.getVideoTabList();
			},
			/**
			 * 预览视频
			 *
			 * @param {object} row 所选对象信息
			 */
			previewVideo(row) {
				this.previewVideoDialog = true;
				this.videoSrc = getCloudUrl(row.videoUrl);
			},
			/**
			 * 设置视频标签状态
			 *
			 * @param {object} row 所选对象信息
			 */
			setVideoTab(row) {
				const params = {
					videoTabID: row.videoTabID,
					isDefault: row.isDefault ? 0 : 1, // 标签状态，0：取消默认，1：设为默认
				};
				setVideoTab(params).then((res) => {
					if (res.code === 200) {
						this.$message({
							type: "success",
							message: "设置成功!",
						});
						this.getVideoTabList();
					} else {
						this.$message({
							type: "warning",
							message: res.message,
						});
					}
				});
			},
			/**
			 * 打开添加视频标签对话框
			 */
			openAddVideoTabDialog() {
				this.addVideoTagsDialog = true;
				this.addVideoTagsForm = {
					isDefault: 0
				}
				this.$nextTick(() => {
					this.$refs["videoTabFormRef"].clearValidate();
				});
			},
			/**
			 * 添加视频标签
			 */
			addVideoTab() {
				this.$refs["videoTabFormRef"].validate((valid) => {
					if (valid) {
						this.addVideoTagsDialog = false;
						const data = {
							videoTabTitle: this.addVideoTagsForm.videoTabTitle,
							isDefault: this.addVideoTagsForm.isDefault,
						};
						addVideoTab(data).then((res) => {
							if (res.code === 200) {
								this.$message({
									message: "添加成功!",
									type: "success",
								});
								this.getVideoTabList();
							} else {
								this.$message({
									message: res.message,
									type: "warning",
								})
							}
						});
					}
				});
			},
			/**
			 * 打开编辑视频标签对话框
			 *
			 * @param {object} row 所选对象信息
			 */
			openEditVideoTabDialog(row) {
				this.$set(this.editVideoTagsForm, "videoTabID", row.videoTabID);
				this.$set(this.editVideoTagsForm, "videoTabTitle", row.videoTabTitle);
				this.$set(this.editVideoTagsForm, "isDefault", row.isDefault);
				this.editVideoTagsDialog = true;
			},
			/**
			 * 编辑视频标签
			 */
			editVideoTab() {
				this.editVideoTagsDialog = false;
				const data = {
					videoTabID: this.editVideoTagsForm.videoTabID,
					videoTabTitle: this.editVideoTagsForm.videoTabTitle,
				};
				updateVideoTab(data).then((res) => {
					if (res.code === 200) {
						this.$message({
							message: "修改成功!",
							type: "success",
						});
						this.getVideoTabList();
					} else {
						this.$message({
							message: res.message,
							type: "warning",
						});
					}
				});
			},
			/**
			 * 删除视频标签
			 *
			 * @param {object} row 所选对象信息
			 */
			deleteVideoTab(row) {
				const params = {
					videoTabID: row.videoTabID,
				};
				this.$confirm("是否删除该视频标签", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
					})
					.then(() => {
						deleteVideoTab(params).then((res) => {
							if (res.code === 200) {
								this.$message({
									type: "success",
									message: "删除成功",
								});
								this.getVideoTabList();
							} else {
								this.$message({
									type: "warning",
									message: res.message,
								});
							}
						});
					})
			},
			/**
			 * 查看视频
			 *
			 * @param {object} row 所选对象信息
			 */
			openVideoListDialog(row) {
				this.videoListDialog = true;

				this.videoListCurrentPage = 1
				this.videoListTotalCount = row.videoList.length
				this.videoListAll = row.videoList

				this.getVideoList(this.videoListCurrentPage)
			},

			/**
			 * 分页获取视频标签列表
			 */
			getVideoTabList() {
				this.loading = true;
				const params = {
					// sortName: "",
					// sortOrder: "",
					pageNumber: this.currentPage || 1,
					pageSize: this.pageSize || 10,
					keyWord: this.searchValue || "",
					where: "",
				};
        setNavigationItemWithObj(this.navigationKey,{
          currentPage:this.currentPage,
          searchValue:this.searchValue
        })

				getVideoTabList(params).then((res) => {
					this.videoTabList = res.data.rows;
					this.totalCount = res.data.total;
					this.loading = false;
				});
			},

		},
	}
</script>

<style>
</style>
